/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable no-case-declarations */
import Fuse from 'fuse.js';
import { formatStringToDate } from 'utils/formatters';
import { findAssignedFeature } from 'utils/license-helpers';
import { USER_SEARCH_KEYS } from './constants';

import { actionTypes, InitialState } from './usersContext';

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_USER_LIST_IS_LOADING:
      state.userListIsLoading = action.isLoading;

      return;
    case actionTypes.SET_USER_CHECKED_STATE:
      const user = state.userList.find((e) => {
        return e.email === action.email;
      });

      if (user) user.checked = !user.checked;
      if (user.checked) {
        state.selectedUserList = [...state.selectedUserList, user];
      }
      if (!user.checked) {
        state.selectedUserList = state.selectedUserList.filter((u) => {
          return u.email !== action.email;
        });
      }

      return;
    case actionTypes.SET_BASE_USER_LIST:
      state.baseUserList = action.userList;

      state.selectedUserList = state.baseUserList.filter((u) => u.checked);

      return;
    case actionTypes.SET_EDIT_USER: {
      state.editUser = action.user;

      return;
    }
    case actionTypes.OPTIMISTICALLY_UPDATE_USER: {
      // find user's index in baseUserList
      const baseUserListIndex = state.baseUserList.findIndex(
        (ele) => ele.email === action.user.email,
      );
      // find user's index in userList
      const userListIndex = state.userList.findIndex(
        (ele) => ele.email === action.user.email,
      );

      if (action.removeFromList) {
        state.userList.splice(userListIndex, 1);
      } else {
        state.userList[userListIndex] = {
          ...state.userList[userListIndex],
          ...action.user,
        };
      }

      state.baseUserList[baseUserListIndex] = {
        ...state.baseUserList[baseUserListIndex],
        ...action.user,
        profiles: action.user.profiles,
      };

      state.userList[userListIndex] = {
        ...state.userList[userListIndex],
        ...action.user,
        profiles: action.user.profiles,
      };

      state.selectedUserList = state.baseUserList.filter((u) => u.checked);

      return;
    }
    case actionTypes.OPTIMISTICALLY_UPDATE_LICENSES: {
      const { assigned, unassigned } = action;

      if (assigned) {
        state.licenseList.forEach((license, index) => {
          if (assigned.includes(license.id)) {
            if (typeof license.number_of_licenses_assigned === 'number') {
              state.licenseList[index].number_of_licenses_assigned += 1;
              state.licenseList[index].number_of_licenses_available -= 1;
            } else {
              state.licenseList[index].numberOfLicensesAssigned += 1;
              state.licenseList[index].numberOfLicensesAvailable -= 1;
            }
          }
        });
      }

      if (unassigned) {
        state.licenseList.forEach((license, index) => {
          if (unassigned.includes(license.id)) {
            if (typeof license.number_of_licenses_assigned === 'number') {
              state.licenseList[index].number_of_licenses_assigned -= 1;
              state.licenseList[index].number_of_licenses_available += 1;
            } else {
              state.licenseList[index].numberOfLicensesAssigned -= 1;
              state.licenseList[index].numberOfLicensesAvailable += 1;
            }
          }
        });
      }

      return;
    }
    case actionTypes.SET_USER_LIST:
      state.userList = action.userList;

      return;
    case actionTypes.SET_FILTER_STATUS:
      state.userFilterStatus = action.userFilterStatus;

      return;
    case actionTypes.FILTER_BASE_USER_LIST:
      state.baseUserList = state.baseUserList.filter((u) => {
        return u.status === state.userFilterStatus;
      });

      return;
    case actionTypes.FILTER_USER_LIST:
      state.userList = state.baseUserList.filter((u) => {
        return u.status === state.userFilterStatus;
      });

      if (action.hasOwnProperty('searchString')) {
        state.userSearchString = action.searchString;
        // We remove field sorting to let Fuse do the sorting
        state.sortField = null;
      }

      if (state.userSearchString.length === 0) {
        // We add back the field sorting
        state.sortField = action.authV3Enabled ? 'firstName' : 'first_name';
        return;
      }

      const options = {
        shouldSort: true,
        threshold: 0.25,
        keys: [
          USER_SEARCH_KEYS.fullName,
          USER_SEARCH_KEYS.email,
          ...state.dynamicColState.map((col) => col.fieldState),
        ],
        getFn: (obj, path) => {
          if (path === USER_SEARCH_KEYS.fullName) {
            return `${obj.first_name ?? obj.firstName} ${
              obj.last_name ?? obj.lastName
            }`;
          }

          if (
            path === USER_SEARCH_KEYS.createdDate ||
            path === USER_SEARCH_KEYS.updatedDate ||
            path === USER_SEARCH_KEYS.deactivatedDate
          ) {
            return formatStringToDate(obj[path]);
          }

          return JSON.stringify(obj[path]);
        },
      };

      const fuse = new Fuse(state.userList, options);

      state.userList = fuse.search(state.userSearchString);

      return;
    case actionTypes.SET_USERLIST_TO_BASE:
      state.userList = state.baseUserList;

      return;
    case actionTypes.SET_DYNAMIC_COL:
      state.dynamicColState = action.dynamicColState;

      return;
    case actionTypes.SET_TABLE_HEADER_STATE:
      state.tableHeaderCheckBox = action.tableHeaderState;

      return;
    case actionTypes.UPDATE_TABLE_SORT:
      state.sortFieldType = action.sortFieldType;
      if (action.sortOrder) {
        state.sortField = action.sortField;
        state.sortOrder = action.sortOrder;

        return;
      }
      if (state.sortField === action.sortField) {
        if (state.sortOrder === 'asc') {
          state.sortOrder = 'desc';
        } else {
          state.sortOrder = 'asc';
        }
      } else {
        state.sortField = action.sortField;
        state.sortOrder = 'asc';
      }

      return;
    case actionTypes.ADD_USER_TO_USER_LIST:
      state.userList.push(action.createdUser);
      state.baseUserList.push(action.createdUser);

      return;
    case actionTypes.TOGGLE_USERS_ACTIVE_STATUS:
      // Update users status in base user list
      state.baseUserList
        .filter((baseUser) => {
          return baseUser.profiles.some((p) =>
            action.profileIds.includes(p.id),
          );
        })
        .forEach((baseUser) => {
          baseUser.status = !state.userFilterStatus;
          baseUser.active = !baseUser.active;
          baseUser.statusDisplay = state.userFilterStatus
            ? 'InActive'
            : 'Active';
          baseUser.updatedDate = new Date();
          baseUser.checked = false;
          if (!baseUser.active) baseUser.deactivatedDate = new Date();
        });
      state.selectedUserList = [];

      // Remove users from display list
      state.userList = state.userList.filter((user) => {
        return user.profiles.some((p) => !action.profileIds.includes(p.id));
      });

      return;
    case actionTypes.SET_TEAMS_OPTIONS:
      state.teamsOptions = action.teamsOptions.toSorted((a, b) => {
        const labelA = a.label.toUpperCase();
        const labelB = b.label.toUpperCase();
        if (labelA < labelB) {
          return -1;
        }
        if (labelA > labelB) {
          return 1;
        }

        return 0;
      });

      return;
    case actionTypes.SET_ROLES_OPTIONS:
      state.rolesOptions = action.rolesOptions;

      return;
    case actionTypes.SET_LOCATIONS_OPTIONS:
      state.locationsOptions = action.locationsOptions;

      return;
    case actionTypes.SET_LICENSE_LIST:
      state.licenseList = action.licenseList;

      const voiceAccess =
        state.licenseList &&
        findAssignedFeature(state.licenseList, 'PLATFORM_VOICE_ACCESS');

      state.voiceAccess = voiceAccess;

      return;
    case actionTypes.SET_NOTIFY_MODEL:
      state.notifyModal = { ...state.notifyModal, ...action.notifyModal };

      return;
    case actionTypes.SET_VOICE_SETUP_MODEL:
      state.voiceSetupModel = {
        ...state.voiceSetupModel,
        ...action.voiceSetupModel,
      };

      return;
    case actionTypes.UPDATE_USER_AMAZONID:
      const baseUserListIndex = state.baseUserList.findIndex(
        (ele) => ele.email === action.email,
      );

      const userListIndex = state.userList.findIndex(
        (ele) => ele.email === action.email,
      );
      const amazonUserAccount =
        state.userList?.[userListIndex]?.profiles?.[0]?.amazonAccount;
      if (amazonUserAccount) {
        if (amazonUserAccount.hasOwnProperty('primary_identifier')) {
          amazonUserAccount.primary_identifier = action.amazonId;
        } else if (amazonUserAccount.hasOwnProperty('PrimaryIdentifier')) {
          amazonUserAccount.PrimaryIdentifier = action.amazonId;
        }
      }
      const amazonBaseAccount =
        state.baseUserList?.[baseUserListIndex]?.profiles?.[0]?.amazonAccount;
      if (amazonBaseAccount) {
        if (amazonBaseAccount.hasOwnProperty('primary_identifier')) {
          amazonBaseAccount.primary_identifier = action.amazonId;
        } else if (amazonBaseAccount.hasOwnProperty('PrimaryIdentifier')) {
          amazonBaseAccount.PrimaryIdentifier = action.amazonId;
        }
      }
      return;
    case actionTypes.POPULATE_ACCOUNT_LEVEL_CX_WORKSPACES:
      state.accountLevelCXWorkspaces = action.payload;
      return;
    case actionTypes.POPULATE_ORIGINAL_USER_LEVEL_CX_WORKSPACES:
      state.originalUserLevelCXWorkspaces = action.payload;
      return;
    case actionTypes.POPULATE_UPDATED_USER_LEVEL_CX_WORKSPACES:
      state.updatedUserLevelCXWorkspaces = action.payload;
      return;
    case actionTypes.POPULATE_NEW_CX_USER_WORKSPACES:
      state.newCXUserWorkspaces = action.payload;
      return;
    default:
      return InitialState;
  }
};
